var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.identifier,staticClass:"dj-view-relative",style:({
              width:_vm.size,
              height:_vm.height+ 'px',
              borderRadius:_vm.borderRadius,
              backgroundColor:_vm.bgColor
            }),on:{"click":_vm.click}},[_vm._t("default",null,{"height":_vm.height})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }